// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Vmk2g_3dDpXfXpi5mJOrT","sidemenu":"_3lVHI_6z0zRNJ_V6Hn7nCr","content":"rt5jMnPuLOaPDyF7nj5ox","boxContent":"_1M5_k5uAyDyIuoGDpGyKlI"};